module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((typeof _vm.menus.Main != 'undefined')) ? _c('div', {
    ref: "component",
    staticClass: "component__main-menu can-scroll"
  }, [_c('ul', {
    staticClass: "main-menu__submenu"
  }, [(_vm.canViewDashboard) ? _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj = {}, _obj[_vm.settingsLinkActiveClass] = _vm.$route.name === 'Index', _obj ),
    attrs: {
      "to": {
        name: 'Index'
      }
    }
  }, [_c('md-icon', [_vm._v("home")]), _vm._v(" "), _c('span', [_vm._v("Dashboard")])], 1)], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.accessMainMenus), function(menu) {
    return _c(menu, {
      key: menu.name,
      tag: "component"
    })
  }), _vm._v(" "), _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item has-arrow has-droprdown"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$root.toggleMenu($event)
      }
    }
  }, [_c('md-icon', {
    staticClass: "arrow-icon-right"
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('md-icon', {
    staticClass: "arrow-icon-down"
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('md-icon', [_vm._v("android")]), _vm._v(" "), _c('span', [_vm._v("Приложение")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.getAPKLink('storekeeper')
      }
    }
  }, [_c('md-icon', [_vm._v("get_app")]), _vm._v(" "), _c('span', [_vm._v("Кладовщик")])], 1), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.getAPKLink('forwarder')
      }
    }
  }, [_c('md-icon', [_vm._v("get_app")]), _vm._v(" "), _c('span', [_vm._v("Экспедитор")])], 1)])])])]), _vm._v(" "), _c('ul', {
    staticClass: "main-menu__submenu foregin"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [((_vm.config && _vm.config.other && _vm.config.other.menuDocsLink)) ? _c('a', {
    attrs: {
      "href": _vm.config.other.menuDocsLink,
      "target": "_blank"
    }
  }, [_c('md-icon', [_vm._v("integration_instructions")]), _vm._v(" "), _c('span', [_vm._v("Инструкции")])], 1) : _vm._e(), _vm._v(" "), ((_vm.config && _vm.config.other && _vm.config.other.menuVersionLink)) ? _c('a', {
    attrs: {
      "href": _vm.config.other.menuVersionLink,
      "target": "_blank"
    }
  }, [_c('md-icon', [_vm._v("history")]), _vm._v(" "), _c('span', [_vm._v("История версий")])], 1) : _vm._e(), _vm._v(" "), _c('a', [_c('md-icon', [_vm._v("system_update_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.$root.appVersion))])], 1), _vm._v(" "), _c('a', [_c('md-icon', [_vm._v("settings_suggest")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.$root.appHash))])], 1)])])], 2) : _vm._e()
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc122fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = 1179
// module chunks = 0